<i class="icon icon-mixed" *ngIf="mixed"></i>

<ng-container *ngIf="!mixed">
    <i class="icon icon-checked" *ngIf="model"></i>
    <i class="icon icon-unchecked" *ngIf="!model"></i>
</ng-container>

<ng-content></ng-content>

